/* eslint-disable no-param-reassign */
import { createReducer } from '@ngrx/store';
import { Bot, Compagnie, User } from '@shared/models';
import {
  deleteBot,
  setBot,
  setBots,
  setCompany,
  setUser,
  upsertBots,
} from './app.actions';
import { immerOn } from 'ngrx-immer/store';

export interface AppReducer {
  company: Compagnie | null;
  user: User | null;
  bots?: Map<string, Bot>;
}

export const initialState: AppReducer = {
  company: null,
  user: null,
  bots: new Map<string, Bot>(),
};

export const appReducer = createReducer(
  initialState,
  immerOn(setUser, (state, payload) => {
    state.user = payload;
    return state;
  }),
  immerOn(setCompany, (state, { company }) => {
    state.company = company;
    return state;
  }),
  immerOn(setBots, (state, { bots }) => {
    state.bots = bots;
    return state;
  }),
  immerOn(upsertBots, (state, { bots }) => {
    if (!state.bots) {
      state.bots = new Map<string, Bot>();
    }
    for (const bot of bots) {
      if (bot.id) {
        state.bots.set(bot.id as string, bot);
      }
    }
    return state;
  }),
  immerOn(setBot, (state, { bot }) => {
    if (state.bots) {
      state.bots.set(bot.id as string, bot);
    }
    return state;
  }),
  immerOn(deleteBot, (state, { id }) => {
    if (state.bots) {
      state.bots.delete(id);
    }
    return state;
  })
);
